import React, { useEffect, useState } from 'react'
import LanguageListTable from '../../common/components/LanguageListTable'
import { Button } from 'react-bootstrap';
import AddLanguage from './AddLanguage';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { getAllLanguagesList } from '../actions/manageLanguagesActions';

const ManageLanguages = () => {
    const dispatch = useDispatch();
    const [formState, setFormState] = useState("list");
    const [selectedLanguage, setSelectedLanguage] = useState('');
    const { allLanguagesList } = useSelector(
      (state) => state.manageLanguagesReducer,
      shallowEqual
    );
  
    // table states
    const [page, setPage] = useState(0);
    
    const handleChangePage = (event, newPage) => {

        
        setPage(newPage);
        dispatch(getAllLanguagesList(newPage, 10));
      };

    const handleFormState = (fState, contentId, content) => {
        formState=='list'&& dispatch(getAllLanguagesList(page, 10));
        setSelectedLanguage(content);
        setFormState(fState);
      };
  useEffect(()=>{
    dispatch(getAllLanguagesList(0,10))
    window.scrollTo(0, 0);

  },[]);
  return (
    <div>
    <p></p>
    <div className="card">
      <div className="card-header">
        <strong>Manage Lanuages</strong>
      </div>
    
      {/* {formState !='create' && formState != 'edit' && <div className="card-body">
        <div className= "row">
            <div className='col-2'>
            </div>
            <div className='col'>
                <Button size='sm' 
                style={{float:'right', margin: '5px'}}
                onClick={()=>handleFormState("create")}
                >Add Language</Button>
            </div>
        </div>    
        <LanguageListTable 
            tableData={
            // []
             (allLanguagesList && allLanguagesList.languages) && allLanguagesList.languages
              ? allLanguagesList.languages
              : []
          }
          totalDataLength={
            // 0
            allLanguagesList && allLanguagesList.totalNumberOfRecords
              ? allLanguagesList.totalNumberOfRecords
              : 0
          }
          page={page}
          handleChangePage={handleChangePage}
          handleFormState={handleFormState}
          isPendingTable={true}
        />
    </div>}
    {(formState =='create' || formState == 'edit') && <div className="card-body"> */}
        <AddLanguage
          handleFormState={handleFormState}
          formState={formState}
          selectedLanguage={selectedLanguage}
          page={page}
          />
        </div>
    {/* } 
    <p></p>
    <p></p>
    </div>*/}
</div>
  )
}

export default ManageLanguages